import doc                 from '@widesk-core/decorators/doc';
import AbstractStandModel  from './AbstractStandModel';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';
import appStore            from '@/stores/appStore';
import { computed }        from 'mobx';

export type StandPageMode = 'all' | 'to_validate';

@doc.urnResource('stand')
export default class StandModel extends AbstractStandModel {
	public getDashboardPath(mode: StandPageMode): string {
		return this.pagePathPrefix + `/stands/mode/${mode}/${this.id}`;
	}

	public static getSplitViewPath(mode: StandPageMode): string {
		return `/stands/mode/${mode}/split`;
	}

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	// Provides a default mode "all" for pagePath
	// Example: renderName({ link: true }) will result in "all" mode
	public get pagePath(): string {
		return this.pagePathPrefix + `/stands/mode/all/${this.id}`;
	}

	public get pagePathPrefix() {
		return `/website_entertainments/${this.get('websiteEntertainment.id')}`;
	}

	public renderName(props?: RenderNameProps<this> & StandNameProps) {
		return super.renderName(props);
	}

	static get urlPrefix() {
		return `${appStore.websiteEntertainment?.url}/exposants/`;
	}

	getUrl(complete = false) {
		const path = StandModel.urlPrefix + this.slug;
		if (complete) {
			return appStore.websiteEntertainment?.website.url + path;
		}

		return path;
	}

	get status() {
		return this.standStatus;
	}

	@computed get contentToPublish() {
		return appStore.collContentToPublish
			.find(m => m.objectUrn === this.urn) || undefined;
	}

	get isPublishScheduled() {
		return this.contentToPublish?.contentToPublishStatus.reference === 'ENABLED';
	}
}
